import React from "react";
import { Header2, PriorityLowIcon } from "@activecollab/components";
import classnames from "classnames";
import classNames from "classnames";
import PropTypes from "prop-types";
import HiddenFromClients from "~/components/tasks/Signifiers/HiddenFromClients";
import TaskCompleteCheckbox from "~/components/tasks/TaskCompleteCheckbox";
import { ProjectTemplateElementsOptionsContainer } from "../ProjectTemplateElementsOptionsContainer";

const TemplateTaskHeader = ({ task, className }) => {
  const isImportant = task?.is_important;
  const isHiddenFromClients = task?.is_hidden_from_clients;

  return (
    <div className={classNames("tw-relative", className)}>
      <div className="tw-flex tw-justify-between tw-mb-2">
        <div>
          <TaskCompleteCheckbox
            taskId={task?.id}
            defaultCompleted={false}
            disabled
            className={classnames("tw-inline-flex tw-align-middle", {
              "tw-mr-3": !isImportant,
            })}
          />
          {isImportant && (
            <PriorityLowIcon
              fill="var(--red-alert)"
              className="tw-mx-1 tw-align-middle"
            />
          )}
          <Header2
            weight="bold"
            as="span"
            className={classnames("tw-align-middle", {
              "tw-text-red-alert": isImportant,
            })}
          >
            {task?.name}
          </Header2>
          <HiddenFromClients
            hiddenFromClients={isHiddenFromClients}
            className="modal-header-icon tw-align-middle"
          />
        </div>
        <div className="tw-flex tw-h-fit tw--mt-1 tw-ml-2">
          <ProjectTemplateElementsOptionsContainer
            elementId={task?.id}
            elementType={task?.class}
            templateId={task?.template_id}
          />
        </div>
      </div>
    </div>
  );
};

TemplateTaskHeader.propTypes = {
  task: PropTypes.object,
  className: PropTypes.string,
};

TemplateTaskHeader.displayName = "TemplateTaskModalHeader";

export default TemplateTaskHeader;
